import { AllowIndicationGuard } from 'src/app/modules/indication/allow-indication.guard';
import { allowRescheduleResolver } from 'src/app/modules/indication/resolver/indication-config.resolver';
import { AdminGuard } from 'src/app/shared/guards/admin.guard';
import { FinanceiroRoleGuard } from 'src/app/shared/guards/financeiro-role.guard';
import { LoggedInGuard } from 'src/app/shared/guards/loggedin.guard';

import { Routes } from '@angular/router';


import { indicationScheduleResolver } from './indication/indication-edit/views/indication-schedule/resolver/indication-schedule.resolver';
import { indicationSummaryResolver } from './indication/indication-edit/views/indication-summary/resolver/indication-summary.resolver';
import { PrivateLayoutComponent } from './private-layout.component';

import { SuperAdminGuard } from 'src/app/shared/guards/superAdmin.guard';


export const privateRoutes: Routes = [
  {
    path: '',
    component: PrivateLayoutComponent,
    canActivate: [LoggedInGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./dashboard/dashboard.component').then((c) => c.DashboardComponent),
      },
      {
        path: 'indications',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./indication/indication-list/indication-list.component').then(
                (c) => c.IndicationListComponent
              ),
            children: [
              { path: '', redirectTo: 'schedule', pathMatch: 'full' },
              {
                path: 'schedule',
                loadComponent: () =>
                  import(
                    './indication/indication-list/components/indication-schedule-list/indication-schedule-list.component'
                  ).then((c) => c.IndicationScheduleListComponent),
              },
              {
                path: 'attendance',
                loadComponent: () =>
                  import(
                    './indication/indication-list/components/indication-attendance-list/indication-attendance-list.component'
                  ).then((c) => c.IndicationAttendanceListComponent),
              },
              {
                path: 'archive',
                loadComponent: () =>
                  import(
                    './indication/indication-list/components/indication-archive-list/indication-archive-list.component'
                  ).then((c) => c.IndicationArchiveListComponent),
              },
            ],
          },
          {
            path: ':id',
            canActivate: [AllowIndicationGuard],
            loadComponent: () =>
              import('./indication/indication-edit/indication-edit.component').then(
                (c) => c.IndicationEditComponent
              ),
            children: [
              {
                path: 'summary',
                resolve: { indicationSummaryResolver: indicationSummaryResolver },
                loadComponent: () =>
                  import(
                    './indication/indication-edit/views/indication-summary/indication-summary.component'
                  ).then((c) => c.IndicationSummaryComponent),
              },
              {
                path: 'schedule',
                resolve: {
                  allowRescheduleResolver: allowRescheduleResolver,
                  indicationScheduleResolver: indicationScheduleResolver,
                },
                loadComponent: () =>
                  import(
                    './indication/indication-edit/views/indication-schedule/indication-schedule.component'
                  ).then((c) => c.IndicationScheduleComponent),
              },
              {
                path: 'services',
                loadComponent: () =>
                  import(
                    './indication/indication-edit/views/indication-services/indication-services.component'
                  ).then((c) => c.IndicationServicesComponent),
              },
              {
                path: 'payment',
                loadComponent: () =>
                  import(
                    './indication/indication-edit/views/indication-payment/indication-payment.component'
                  ).then((c) => c.IndicationPaymentComponent),
              },
            ],
          },
        ],
      },
      {
        path: 'administrative/report',
        canActivate: [FinanceiroRoleGuard],
        loadComponent: () =>
          import('./administrative-report/administrative-report.component').then(
            (c) => c.AdministrativeReportComponent
          ),
        children: [
          { path: '', redirectTo: 'financial-analytic', pathMatch: 'full' },
          {
            path: 'financial-analytic',
            loadComponent: () =>
              import('./administrative-report/tabs/financial-analytic/financial-analytic-report.component').then(
                (c) => c.FinancialAnalyticReportComponent
              ),
          },
          {
            path: 'pending-invoices',
            loadComponent: () =>
              import('./administrative-report/tabs/pending-invoices/pending-invoices-report.component').then(
                (c) => c.PendingInvoicesReportComponent
              ),
          },
          {
            path: 'transfer-previdas',
            loadComponent: () =>
              import('./administrative-report/tabs/transfer-previdas/transfer-previdas.component').then(
                (c) => c.TransferPrevidasComponent
              ),
          },
          {
            path: 'invoice-doctor',
            loadComponent: () =>
              import('./administrative-report/tabs/invoice-doctor/invoice-doctor.component').then(
                (c) => c.InvoiceDoctorComponent
              ),
          },
          {
            path: 'doctor-transfer',
            loadComponent: () =>
              import('./administrative-report/tabs/doctor-transfer/doctor-transfer.component').then(
                (c) => c.DoctorTransferComponent
              ),
          },
        ],
      },
      {
        path: 'administrative',
        children: [
          {
            path: 'communicare-sync-report',
            canActivate: [SuperAdminGuard],
            loadComponent: () =>
              import('./administrative/communicare-sync-report/communicare-sync-report.component')
                .then((c) => c.CommunicareSyncReportComponent),
          },
        ],
      },
      {
        path: 'administrative/wallet',
        canActivate: [FinanceiroRoleGuard],
        loadComponent: () =>
          import('./administrative-wallet/administrative-wallet.component').then(
            (c) => c.AdministrativeWalletComponent
          ),
      },
      {
        path: 'account/integrations',
        canActivate: [AdminGuard],
        loadComponent: () =>
          import('./account/integrations/integrations.component').then(
            (c) => c.IntegrationsComponent
          ),
      },
      { path: '', redirectTo: 'indications', pathMatch: 'full' },
    ],
    providers: [],
  },
];
